<template>
  <div>
    ระบบ QC
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>
